import { AppleLogo } from '@jouzen/ecom-components/icons/AppleLogo';
import { CorePowerYogaLogo } from '@jouzen/ecom-components/icons/CorePowerYogaLogo';
import { GoogleHealthConnectLogo } from '@jouzen/ecom-components/icons/GoogleHealthConnectLogo';
import { SculptSocietyLogo } from '@jouzen/ecom-components/icons/SculptSocietyLogo';
import { StravaLogo } from '@jouzen/ecom-components/icons/StravaLogo';
import { TechnoGymLogo } from '@jouzen/ecom-components/icons/TechnoGymLogo';
import { WildLogo } from '@jouzen/ecom-components/icons/WildLogo';
import { cx } from 'class-variance-authority';
import type { SVGIconComponent, SVGIconComponentProps } from 'types/svgr';

import type { LandingPageIntegrationData } from '@/app/components/LandingPage/LandingPageIntegrations/types';

const TechnoGymColoredLogo = (props: SVGIconComponentProps) => (
  <TechnoGymLogo {...props} secondaryFill="#f7f1e8" />
);

const activityAndMovementIntegrationsData: LandingPageIntegrationData[] = [
  {
    description: 'activity_strava_copy',
    Logo: StravaLogo as SVGIconComponent,
    name: 'strava',
  },
  {
    description: 'activity_corepoweryoga_copy',
    Logo: CorePowerYogaLogo as SVGIconComponent,
    name: 'corepoweryoga',
  },
  {
    description: 'activity_google_apple_copy',
    logos: [
      {
        Icon: GoogleHealthConnectLogo as SVGIconComponent,
        name: 'google',
      },
      {
        Icon: AppleLogo as SVGIconComponent,
        name: 'apple',
      },
    ],
    name: 'googleapple',
    logoClassName: 'max-w-20 overflow-hidden',
  },
  {
    description: 'activity_sculpt_society_copy',
    Logo: SculptSocietyLogo as SVGIconComponent,
    name: 'thesculptsociety',
  },
  {
    description: 'activity_wild_copy',
    Logo: WildLogo as SVGIconComponent,
    name: 'wild',
  },
  {
    description: 'activity_technogym_copy',
    Logo: TechnoGymColoredLogo as SVGIconComponent,
    name: 'technogym',
  },
].map(
  (integration) =>
    ({
      ...integration,
      logoClassName: cx('h-16', integration.logoClassName),
    }) as LandingPageIntegrationData,
);

export default activityAndMovementIntegrationsData;
